module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-bar-graph-fill-be43a401.svg";